import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../../redux/root-reducer";
import { Course } from "../../../../@types/course.interface";
import { fetchApi } from "../../../../redux/fetch/fetch.actions";
import { Dispatch } from "redux";
import Loading from "../../../../components/loading/loading.component";
import QuizActionAPI, {
    ICreateQuizPayload,
} from "../../../../redux/quiz/quiz.actions";
import { User } from "../../../../@types/user.interface";
import { useHistory } from "react-router-dom";
import { validateQuizForm } from "../../../../utils/validation";
import QuizForm from "../../../../components/quiz-form/quiz-form.component";
import { QuizBasic } from "../../../../@types/quiz.interfaces";

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    user: User | null;
    courses: Course[];
    createQuiz: (data: ICreateQuizPayload["data"]) => void;
    fetchCourses: () => void;
    clearQuizzes: () => void;
}

function CreateQuizContainer({
    isFetching,
    errors,
    user,
    courses,
    createQuiz,
    fetchCourses,
    clearQuizzes,
}: IProps) {
    const history = useHistory();

    const [quiz, setQuiz] = useState<QuizBasic>({
        user_id: 0,
        course_id: 0,
        quiz_duration: 0,
    });

    useEffect(() => {
        if (isFetching || errors) return;
        if (courses.length === 0) fetchCourses();
        if (user?.user_id)
            setQuiz((prevState) => ({
                ...prevState,
                user_id: user.user_id,
            }));
    }, [isFetching, errors, user, fetchCourses, courses]);

    useEffect(() => {
        if (isFetching === false)  {
            history.replace("/quiz/view");
            window.location.reload();
        }
        return () => {
            clearQuizzes();
        };
    }, [isFetching, history, clearQuizzes]);

    const handleChange = (evt: any, name: string) => {
        let val = evt.target.value;
        val = parseInt(val);
        if (val < 0) {
            val = 0;
            evt.target.value = 0;
        } else if (val > 10000000000) {
            val = 10000000000;
            evt.target.value = 10000000000;
        }
        setQuiz((prevState) => ({
            ...prevState,
            [name]: val,
        }));
    };

    const [error, setError] = useState("");

    const handleClick = async (evt: any) => {
        evt.preventDefault();
        setError(validateQuizForm(quiz, errors));
        if (validateQuizForm(quiz, errors) === "") {
            createQuiz(quiz);
        }
    };

    return (
        <div className="container">
            {isFetching ? (
                <Loading className="fixed" />
            ) : (
                <div className="container__content">
                    <QuizForm
                        quiz={quiz}
                        courses={courses}
                        handleClick={handleClick}
                        handleChange={handleChange}
                        error={error}
                    />
                </div>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    user: {
        self: { data },
    },
    courses: { courses },
}: GlobalState) => ({
    isFetching: isFetching.CREATE_QUIZ,
    errors: errors.CREATE_QUIZ,
    user: data,
    courses,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    createQuiz: (data: ICreateQuizPayload["data"]) =>
        dispatch(fetchApi({ name: "CREATE_QUIZ", data })),
    fetchCourses: () => dispatch(fetchApi({ name: "COURSE" })),
    clearQuizzes: () => dispatch(QuizActionAPI.clearQuizzes()),
});

const CreateQuizPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateQuizContainer);

export default CreateQuizPage;
